import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const SBROFUT_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/sbrofut/logo.png",
        alt: "Sundance Behavioral Resources Logo",
        style: { width: "300px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 27,
  state: "UT",
  departmentIds: [101, 109, 111],
};
